import classNames from "classnames";
import React, { type ButtonHTMLAttributes } from "react";

interface IProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  as?: "text" | "wrapper" | "square";
  isActive?: boolean;
  variant?: "primary" | "secondary";
  loading?: boolean;
}

export default function Button({
  className,
  children,
  type = "button",
  onClick,
  disabled,
  as = "wrapper",
  variant = "primary",
  isActive = true,
  loading = false,
  ...props
}: IProps) {
  return (
    <button
      className={classNames(
        "flex cursor-pointer disabled:cursor-not-allowed",
        !isActive && "text-dark-grey hover:text-black dark:hover:text-white",
        as === "text" && [
          variant === "primary" && "text-black dark:text-white",
          variant === "secondary" && "text-dark-grey hover:text-black dark:hover:text-white",
        ],
        as === "square" && [
          "pc:text-base pc:h-7.5 h-10 items-center! px-3 py-1.5 text-base!",
          variant === "primary" && "border-black bg-black text-white dark:bg-white dark:text-black",
          variant === "secondary" &&
            "border-dark-grey flex flex-col gap-2.5 border bg-white text-black dark:border-white dark:bg-black dark:text-white",
        ],
        className,
      )}
      disabled={disabled || loading}
      onClick={onClick}
      type={type}
      {...props}
    >
      {loading ? "Loading..." : children}
    </button>
  );
}
